import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import MessageTemplateSelector from './MessageTemplateSelector';
import MessageContentEditor from './MessageContentEditor';
import CommercialRelaunchEditor from 'src/components/campaign/campaignEditor/editorComponents/campaignContent/CommercialRelaunchEditor';
import { CONTENT_SELECTOR } from '../MassActionEditor';
import MessageActionAppBar from './MessageActionAppBar';
import XplorActiveNewsEditor from './XplorActiveNewsEditor';
import ActionType from 'src/enums/actionType';
import XplorActiveNewsInitialContentSelector from './XplorActiveNewsInitialContentSelector';

export const [TEMPLATE_SELECTOR, CONTENT_EDITOR, COMMERCIAL_RELAUNCH] = [0, 1, 2];

function MassActionMessage({
  initialStep,
  initialExtraProps,
  actionType,
  actionId,
  goToStep,
  isWritable,
}) {
  const [step, setStep] = useState(initialStep); // --> message step, not one off editor step
  const [extraProps, setExtraProps] = useState(initialExtraProps);

  const enhancedSetStep = useCallback((stepId, newExtraProps) => {
    setExtraProps(newExtraProps || {});
    setStep(stepId);
  }, []);

  const propsToSpread = {
    step,
    setStep: enhancedSetStep,
    goToStep,
    actionType,
    actionId,
    isWritable,
    ...extraProps,
  };

  switch (step) {
    case TEMPLATE_SELECTOR:
      if (actionType === ActionType.XPLORACTIVE_NEWS.id) {
        return (
          <XplorActiveNewsInitialContentSelector
            onCancel={() => {
              goToStep(CONTENT_SELECTOR);
            }}
            {...propsToSpread}
          />
        );
      }
      return <MessageTemplateSelector {...propsToSpread} />;
    case CONTENT_EDITOR:
      if (actionType === ActionType.XPLORACTIVE_NEWS.id) {
        return (
          <XplorActiveNewsEditor
            isWritable={isWritable}
            onCancel={() => {
              goToStep(CONTENT_SELECTOR);
            }}
            {...propsToSpread}
          />
        );
      }
      return <MessageContentEditor {...propsToSpread} />;
    case COMMERCIAL_RELAUNCH:
      return (
        <>
          <MessageActionAppBar
            setStep={setStep}
            goToStep={goToStep}
            actionType={actionType}
            actionId={actionId}
            isWritable={isWritable}
          />
          <CommercialRelaunchEditor
            isMassAction
            onCancel={() => {
              goToStep(CONTENT_SELECTOR);
            }}
            {...propsToSpread}
          />
        </>
      );

    default:
      return null;
  }
}

MassActionMessage.propTypes = {
  actionType: PropTypes.number,
  actionId: PropTypes.number,
  initialStep: PropTypes.number,
  initialExtraProps: PropTypes.object,
  goToStep: PropTypes.func.isRequired,
  isWritable: PropTypes.bool.isRequired,
};

MassActionMessage.defaultProps = {
  actionType: null,
  actionId: null,
  initialStep: 0,
  initialExtraProps: {},
};

export default MassActionMessage;
